import store from './store'; 
import { saveWalletData } from './actions';

const updateWalletData = (isFakeWallet: boolean) => {
  store.dispatch(saveWalletData( isFakeWallet));
};

export default updateWalletData;
